import AppInputField from "components/shared/FormComponents/AppInputField";

const Question = ({ question, fieldName }) => {
  return (
    <AppInputField
      name={`${fieldName}.answer`}
      placeholder={question.placeholder}
      fieldType={"textarea"}
      rows={4}
      className="form-control h-auto rounded-3 bg-white"
    />
  )
}

export default Question;